var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pts)?_c('svg',{staticClass:"sd-spark",style:({width: _vm.w + 'px', direction: 'ltr'}),attrs:{"viewBox":`0 0 ${_vm.w} ${_vm.h}`,"aria-hidden":"true"}},[_c('polyline',{attrs:{"points":_vm.pts,"fill":"none","stroke":_vm.color,"stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round","opacity":".75"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }